import { getAnalyticsItemCategoriesByTaxonomy } from './getAnalyticsItemCategoriesByTaxonomy';
import { pushItemImageSelectedDataLayer } from './pushItemImageSelectedDataLayer';
import { ProductSearchMaterial } from '../../../../pages/ProductSearch/types';

export const handleMiniPdpItemImageSelectedDataLayer = (
  product: ProductSearchMaterial,
) => {
  pushItemImageSelectedDataLayer([
    {
      item_id: product?.entityId,
      item_name: product?.name,
      item_brand: product?.manufacturer,
      ...getAnalyticsItemCategoriesByTaxonomy(product?.taxonomy),
      index: 1,
      price: 0,
      quantity: 1,
      item_list_id: 'quick_view',
      item_list_name: 'Quick View',
      item_variant: product?.name,
    },
  ]);
};
